import { Anchor, Card, Group, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router';

/**
 * KAYIT DETAYI (P5 · P6 — Kapsam §20.3b).
 *
 * ⚠️ **SEKME YOKTUR — BÖLÜMLER ALT ALTA.** Sekme yalnız **MODÜL düzeyindedir**
 * (§20.3a'nın rota tabanlı sekme şeridi). Üç gerekçe:
 *   1. Her şey tek kaydırmada görünür; *"sürüm geçmişi hangi sekmedeydi"*
 *      diye aranmaz.
 *   2. **PDF'E GİDEN ŞEY SAYFANIN KENDİSİDİR** (S6.5 çıktı motoru):
 *      sekmelere bölünmüş bir detaydan tek parça çıktı almak, **ekranla
 *      çıktının farklı şeyler göstermesi** demektir.
 *   3. Sekmede gizli kalan bölümü kullanıcı **olmadığını sanar**.
 *
 * Bu bileşen `Tabs` KULLANMAZ ve kullanmamalıdır — kural bir yorum değil,
 * yapının kendisidir.
 *
 * ⚠️ **P6 — DÖNÜŞ YOLU EKRANIN KENDİSİNDEDİR:** menüde satırı olmayan
 * sayfadan kullanıcı menüyle çıkamaz; bağlantı olmazsa **sıkışır**.
 */
export function KayitDetayi({
  geriYol,
  geriEtiket,
  baslik,
  ustBilgi,
  eylemler,
  children,
  testId,
}: {
  geriYol: string;
  geriEtiket: string;
  baslik: string;
  ustBilgi?: React.ReactNode;
  eylemler?: React.ReactNode;
  children: React.ReactNode;
  testId?: string;
}): React.JSX.Element {
  return (
    <Stack data-testid={testId}>
      <Anchor component={Link} to={geriYol} size="sm" data-testid="detay-geri">
        ← {geriEtiket}
      </Anchor>
      <Group justify="space-between" align="flex-start">
        <Stack gap={4}>
          <Title order={3}>{baslik}</Title>
          {ustBilgi}
        </Stack>
        {eylemler}
      </Group>
      {children}
    </Stack>
  );
}

/** Detayın bir bölümü — alt alta dizilir, sekmeye BÖLÜNMEZ (P5). */
export function Bolum({
  baslik,
  aciklama,
  children,
  testId,
}: {
  baslik: string;
  aciklama?: string;
  children: React.ReactNode;
  testId?: string;
}): React.JSX.Element {
  return (
    <Card withBorder padding="md" data-testid={testId}>
      <Text fw={600} mb={aciklama ? 2 : 'xs'}>
        {baslik}
      </Text>
      {aciklama && (
        <Text size="xs" c="dimmed" mb="xs">
          {aciklama}
        </Text>
      )}
      {children}
    </Card>
  );
}
